import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Flex,
  Text,
  Select,
  Spinner,
  Td,
  Button,
  useToast,
  Input,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Tag,
  TagLabel,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Badge,
  Center,
} from "@chakra-ui/react";
import {
  FaEllipsisV,
  FaEdit,
  FaTrash,
  FaSync,
  FaPrint,
  FaPlus,
} from "react-icons/fa";
import axios from "axios";
import SubjectModal from "./SubjectModal";
import "../Teacher/teacher.css";
import { Link } from "react-router-dom";
import Print_pdf_subject_class from "./Print_pdf_subject_class";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Subject_Class = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedClass, setSelectedClass] = useState(""); // Holds selected class ID
  const [selectedSubjects, setSelectedSubjects] = useState([]); // Holds selected subject IDs
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const toast = useToast();
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]); // New state for subject list

  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();

  const jwtToken = sessionStorage.getItem("jwt"); // Get JWT token from session storage

  useEffect(() => {
    fetchData();
  }, [jwtToken]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/subject/list_all_subject_to_class.php`,
        {
          headers: { Authorization: `Bearer ${jwtToken}` },
        }
      );
      setData(response.data.data || []);
      setIsDataLoaded(true); // Mark data as loaded

      console.log(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast({
        title: "Error fetching data",
        description: "Unable to load subjects. Please try again later.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };
  const handleEdit = (item) => {
    console.log("Editing item:", item); // Log the item to check its structure
    if (item && item.class_id) {
      setSelectedClass(item.class_id); // Set the selected class ID
    } else {
      console.error("Item does not have class_id:", item);
    }
    // Set the selected subjects based on the received item
    setSelectedSubjects(item.subjects.map((subject) => subject.id) || []);
    setIsEditMode(true);
    setIsModalOpen(true);
  };

  const openModal = (editMode = false) => {
    setIsEditMode(editMode);
    setIsModalOpen(true);
  };

  const handleSuccess = () => {
    fetchData(); // Refresh the list after create/edit
  };

  const filteredData = data.filter((item) =>
    item.class.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const deleteItem = async (class_subject_id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/admin/subject/delete_subject_to_class.php`,
        {
          headers: { Authorization: `Bearer ${jwtToken}` },
          data: { class_subject_id },
        }
      );

      if (response.data.success) {
        fetchData();
        toast({
          title: "Subject deleted.",
          description: "The subject has been successfully deleted.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Failed to delete.",
          description:
            response.data.message ||
            "An error occurred while deleting the subject.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error during deletion:", error);
      toast({
        title: "Error",
        description:
          "An error occurred while trying to delete the subject. Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const renderRow = (item) => {
    return (
      <Tr key={item.class_id}>
        <Td py="12px" px="20px" textAlign="left">
          <Box textAlign="center">{item.class}</Box>
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          {item.subjects && item.subjects.length > 0
            ? item.subjects.map((subject, index) => (
                <Tag key={index} m={1} colorScheme="teal">
                  <TagLabel>{subject}</TagLabel>
                </Tag>
              ))
            : "No subjects available"}
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          <Box textAlign="left">
            <Badge
              colorScheme={item.status === "Active" ? "green" : "green"}
              borderRadius="full"
              px={4}
              py={1}
              fontSize="11px"
              boxShadow="md"
              position="relative"
            >
              {item.status === "Active" ? "Active" : "Active"}
            </Badge>
          </Box>
        </Td>
        <Td py="12px" px="20px" textAlign="left">
          <Box textAlign="center">
            <Menu>
              <MenuButton
                as={IconButton}
                size="sm"
                variant="ghost"
                icon={<FaEllipsisV />}
              />
              <MenuList>
                <MenuItem
                  onClick={() => handleEdit(item)}
                  icon={<FaEdit color="blue" />}
                >
                  Edit
                </MenuItem>
                {/* <MenuItem
                onClick={() => deleteItem(item.class_subject_id)}
                icon={<FaTrash color="red" />}
              >
                Delete
              </MenuItem> */}
              </MenuList>
            </Menu>
          </Box>
        </Td>
      </Tr>
    );
  };

  return (
    <Box maxWidth="100%" overflowX="auto">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px" }}>Assign Subjects To Class</h1>
            <div className="action-buttons">
              {/* <Button
                className="refresh-button"
                boxShadow="md"
                backgroundColor="white"
                fontSize="11px"
                onClick={fetchData}
                display={{ base: "none", md: "flex" }}
              >
                <FaSync color="#515B73" />
              </Button> */}

              <Button
                className="export-button"
                display={{ base: "none", md: "flex" }}
                backgroundColor="white"
                fontSize="11px"
                boxShadow="md"
                onClick={handlePrint} // Attach the print handler here
              >
                <FaPrint color="#515B73" />
                Print PDF
              </Button>

              <Button
                colorScheme="teal"
                leftIcon={<FaPlus />}
                onClick={() => openModal(false)}
                mb={4}
              >
                <Box display={{ base: "none", md: "block" }}>
                  Add Subject to Class
                </Box>
              </Button>
            </div>
          </div>

          <div className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span> Class</span>/ <span>Subject- Class</span>
          </div>
        </div>

        <Box p={6}>
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align="center"
            mb={1}
            className="sb"
            p={3}
          >
            <Flex align="center">
              <Text mr={2}>Rows Per Page</Text>
              <Select
                width="100px"
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </Select>
            </Flex>
            <Stack direction="row" spacing={4}>
              <Input
                mt={{ base: "2" }}
                type="text"
                placeholder="Search by class name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Stack>
          </Flex>

          {loading ? (
            <Spinner size="lg" />
          ) : (
            <Box overflowX="auto">
              <Table
                sx={{
                  "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
                }}
              >
                <Thead>
                  <Tr>
                    <Th>
                      <Box textAlign="center"></Box>
                      Class Name
                    </Th>
                    <Th>
                      <Box textAlign="left">Subjects</Box>
                    </Th>
                    <Th>
                      <Box textAlign="center">Status</Box>
                    </Th>
                    <Th>
                      <Box textAlign="center">Actions</Box>
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentData.length > 0 ? (
                    currentData.map(renderRow)
                  ) : (
                    <Tr>
                      <Td colSpan="4" textAlign="center">
                        No data available
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </Box>
          )}

          {/* Pagination controls */}
          <Flex justify="end" align="center" p={3} className="sb2">
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" spacing={2} mx={2}>
              {Array.from({ length: totalPages }, (_, i) => (
                <Button
                  key={i}
                  onClick={() => handlePageChange(i + 1)}
                  colorScheme={currentPage === i + 1 ? "teal" : "gray"}
                >
                  {i + 1}
                </Button>
              ))}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>
        </Box>
      </div>
      <div style={{ display: "none" }}>
        <Print_pdf_subject_class ref={printComponentRef} subjects={subjects} />
      </div>
      {isModalOpen && (
        <SubjectModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          isEditMode={isEditMode}
          selectedClass={selectedClass} // Pass the selected class ID
          selectedSubjects={selectedSubjects} // Pass the selected subjects
          onSuccess={handleSuccess}
        />
      )}
      {console.log("Selected Class before rendering modal:", selectedClass)}{" "}
      {/* Log it here */}
    </Box>
  );
};

export default Subject_Class;
